<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Godaddy account -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <fieldset class="mb-3" :class="{'loading-mask': loading}">
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Token name</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.name">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Api key</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.api_key">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Api secret</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.api_secret">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-form-label col-lg-2" @click="check_api">Check API keys</label>
                <div class="col-lg-8">
                    <div class="form-check form-check-inline">
                        <div class="uniform-checker">
                            <span :class="{'checked':check_api}">
                                <input type="checkbox" class="form-check-input-styled" v-model="check_api">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{err}}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'

export default {
    components: { modal },
    props: {
        id: null,
    },
    data() {
        return {
            form: {
                _id: null,
                name: null,
                api_key: null,
                api_secret: null
            },
            check_api: true,
            loading: false,
            err: null
        }
    },
    methods: {
        save() {

            if (!this.check_api) {
                return this._save()
            }

            this.loading = true
            this.$api.postReq('test_api_access', {
                provider: 'godaddy',
                api_key: this.form.api_key,
                api_secret: this.form.api_secret
            }).then(res => {
                this._save()
            }).catch(res => {
                this.err = 'Cannot connect to API, invalid API keys'
                this.loading = false
            })

        },
        _save() {
            this.loading = true
            this.$api.postReq('accounts/godaddy', this.form).then(res => {
                this.$emit('close')
                this.$emit('reload')
                this.loading = false
            }).catch(res => {
                this.err = res.body.error
                this.loading = false
            })
        }
    },
    mounted() {

        if (typeof this.id !== 'string') {
            return
        }

        // this.$api.getReq('access_token/show/' + this.id).then(res => {
        //     this.form = res.body.data
        //     this.form.queues = this.form.queues.map(q => {
        //         return {
        //             name: this.queues.filter(_q => _q._id === q).pop().name,
        //             _id: q
        //         }
        //     })
        // })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/Godaddy.vue